import styled from "styled-components";

const Header = styled.header`
  background: #35424a;
  color: white;
  padding: 0px 0;
`;

export default Header;
